import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error-page',
  standalone: true,
  template: `

    <div style="padding:80px 0 60px 0;">
      <h2>Unexpected Error</h2>
      <p style="text-align: center; padding-top:40px;">
      An unexpected error occurred while validating access.
      <br />
      Please try again later.
      </p>
    </div>  

  `
})
export class ErrorPageComponent {
  message = 'Something went wrong.';
  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      if (params['message']) this.message = params['message'];
    });
  }
}